// Liste mit data-sortable-list="<Formular-ID>": ihre Einträge (data-sortable-item="<Kennung>")
// lassen sich per Ziehen umsortieren, etwa die Themen-Kacheln. Hat sich die Reihenfolge beim
// Loslassen geändert, schickt das Formular sie als order[] ab. Ohne JavaScript bleiben die Knöpfe
// je Eintrag.
export default function sortable() {
  document.querySelectorAll('[data-sortable-list]').forEach(function (list) {
    const form = document.getElementById(list.dataset.sortableList);
    if (!form) return;
    let dragged = null;
    let before = '';

    const order = function () {
      return Array.from(list.querySelectorAll('[data-sortable-item]')).map(function (item) {
        return item.dataset.sortableItem;
      });
    };

    list.querySelectorAll('[data-sortable-item]').forEach(function (item) {
      item.draggable = true;
      item.addEventListener('dragstart', function (event) {
        dragged = item;
        before = order().join(',');
        item.classList.add('is-dragging');
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', item.dataset.sortableItem);
      });
      // Über einem anderen Eintrag: davor, wenn der Zeiger in seiner vorderen Hälfte steht, sonst dahinter.
      item.addEventListener('dragover', function (event) {
        if (!dragged || dragged === item) return;
        const box = item.getBoundingClientRect();
        const after = event.clientY > box.bottom - box.height / 4 || event.clientX > box.left + box.width / 2;
        list.insertBefore(dragged, after ? item.nextSibling : item);
      });
      item.addEventListener('dragend', function () {
        item.classList.remove('is-dragging');
        dragged = null;
        const now = order();
        if (now.join(',') === before) return;
        form.querySelectorAll('input[name="order[]"]').forEach(function (input) { input.remove(); });
        now.forEach(function (id) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'order[]';
          input.value = id;
          form.appendChild(input);
        });
        form.requestSubmit();
      });
    });

    // Ablegen ist überall in der Liste erlaubt - sonst springt der Mauszeiger auf „verboten“.
    list.addEventListener('dragover', function (event) {
      if (dragged) event.preventDefault();
    });
    list.addEventListener('drop', function (event) {
      if (dragged) event.preventDefault();
    });
  });
}
